module.exports = __webpack_public_path__ + "static/media/StrengthMagazineSpread6.b87d87cf.jpg";